<template>
    <el-row :gutter="20" align="center">
        <el-col :span="24">
            <el-form-item label="Supplier Name">
                <el-input v-model="supplierDetails.name" placeholder="Supplier Name"/>
            </el-form-item>
        </el-col>
        <el-col :span="12">
            <h4>Contact Details</h4>
            <el-row :gutter="10">
                <el-col :span="12">
                    <el-form-item label="First Name">
                        <el-input v-model="supplierDetails.firstName" placeholder="First Name"/>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="Last Name">
                        <el-input v-model="supplierDetails.lastName" placeholder="Last Name"/>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-form-item label="Phone">
                <el-input v-model="supplierDetails.phone" placeholder="Phone Number"/>
            </el-form-item>
            <el-form-item label="Email">
                <el-input v-model="supplierDetails.email" placeholder="Email Address"/>
            </el-form-item>
        </el-col>
        <el-col :span="12">
            <!--            <h4>Address Details</h4>-->
            <!--            <el-form-item label="Address">-->
            <!--                <el-input v-model="address" placeholder="Address"/>-->
            <!--            </el-form-item>-->
            <!--            <el-row :gutter="10">-->
            <!--                <el-col :span="12">-->
            <!--                    <el-form-item label="City">-->
            <!--                        <el-input v-model="city" placeholder="City"/>-->
            <!--                    </el-form-item>-->
            <!--                </el-col>-->
            <!--                <el-col :span="12">-->
            <!--                    <el-form-item label="Postal / Zip Code">-->
            <!--                        <el-input v-model="postCode" placeholder="Postal / Zip Code"/>-->
            <!--                    </el-form-item>-->
            <!--                </el-col>-->
            <!--            </el-row>-->
            <!--            <el-row>-->
            <!--                <el-col :span="12">-->
            <!--                    <el-form-item label="Country">-->
            <!--                        <el-select v-model="country" placeholder="Select your Country" size="large">-->
            <!--                            <el-option-->
            <!--                                    v-for="country of countries"-->
            <!--                                    :value="country.value"-->
            <!--                                    :label="country.name"-->
            <!--                                    :key="country.value"/>-->
            <!--                        </el-select>-->
            <!--                    </el-form-item>-->
            <!--                </el-col>-->
            <!--                <el-col :span="12">-->
            <!--                    <el-form-item label="State/Territory">-->
            <!--                        <el-select v-model="province" placeholder="Select your State/Territory">-->
            <!--                            <el-option v-for="state of states" :key="state" :value="state" :label="state"/>-->
            <!--                        </el-select>-->
            <!--                    </el-form-item>-->
            <!--                </el-col>-->
            <!--            </el-row>-->
        </el-col>
    </el-row>
</template>

<script>
    export default {
        props: {
            currentSupplier: Object
        },
        data: () => ({
            supplierDetails: {
                name: "",
                firstName: "",
                lastName: "",
                phone: "",
                email: "",
            }
        }),
        mounted() {
            if (this.currentSupplier._id) {
                this._populateFormData();
            }
        },
        methods: {
            _populateFormData() {
                this.supplierDetails = {...this.currentSupplier};
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>